import { Injectable } from '@angular/core';
import { FormTemplateInterface } from '@rx-applications/shared/utils-forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ControlsOf } from '@rx-applications/shared/utils';
import { patterns, RxValidators } from '@roomex/rx-components';
import { Guest } from '../../models';

export interface GuestsForm extends Guest {
  confirmed?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GuestFormService implements FormTemplateInterface<GuestsForm> {
  constructor(private formBuilder: FormBuilder) {}

  getTemplate(defaultValue?: Guest): FormGroup<ControlsOf<GuestsForm>> {
    return this.formBuilder.group<ControlsOf<Guest>>({
      id: this.formBuilder.control(defaultValue?.id),
      title: this.formBuilder.control(defaultValue?.title, [Validators.required]),
      firstName: this.formBuilder.control(defaultValue?.firstName, [
        Validators.required,
        RxValidators.matches(patterns['name']),
      ]),
      lastName: this.formBuilder.control(defaultValue?.lastName, [
        Validators.required,
        RxValidators.matches(patterns['name']),
      ]),
      email: this.formBuilder.control(defaultValue?.email, [Validators.required, Validators.email]),
    });
  }

  addGuestConfirmedControl(form: FormGroup<ControlsOf<GuestsForm>>): void {
    form.addControl('confirmed', this.formBuilder.control(null, [Validators.required]));
  }
}
